var _path, _path2, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeEstimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67773 2.75H8.92121V4.62826C8.92121 6.35235 7.52356 7.75 5.79947 7.75C4.07538 7.75 2.67773 6.35235 2.67773 4.62826V2.75Z",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92139 13.25L2.67791 13.25L2.67791 11.3717C2.67791 9.64765 4.07556 8.25 5.79965 8.25C7.52374 8.25 8.92139 9.64765 8.92139 11.3717L8.92139 13.25Z",
    stroke: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9561,
    y: 2.75,
    width: 10.313,
    height: 2,
    rx: 1,
    transform: "rotate(180 10.9561 2.75)",
    fill: "white",
    stroke: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.643066,
    y: 13.25,
    width: 10.313,
    height: 2,
    rx: 1,
    fill: "white",
    stroke: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeEstimate);
export default __webpack_public_path__ + "static/media/timeEstimate.77d03c76aa8c1bf4255482f9350606cd.svg";
export { ForwardRef as ReactComponent };